module.exports = "../../../../platform/assets/pageMainIcon/industry_baobiaochaxunlei7.svg";